// extracted by mini-css-extract-plugin
export default {"toggleBtn":"styles_toggleBtn__9Mpo1","profilePicture":"styles_profilePicture__Y7J0K","header":"styles_header__710zf","dropdownItem":"styles_dropdownItem__Lm7x1"};